module.exports = __webpack_public_path__ + "img/qa-alt.4bb07581.png";